import * as React from 'react';
import { Entry } from 'contentful';

import styled, { tstyled } from '../../../theme';
import { IProjectContent } from '../../../models/Project';
import VideoOrImage from './VideoOrImage';

interface IProps {
  projectContent: Entry<IProjectContent>;
  containerWidth: number;
}

const Container = tstyled<{ containerWidth: number }>(styled.div)`
  display: flex;
  justify-content: space-between;

  @media (max-width: ${props => props.theme.mobileBreakpoint - 1}px) {
    padding: 0 ${props => props.theme.mobilePadding}px;
    flex-wrap: wrap;
    align-items: flex-start;

    > * {
      flex-grow: 0;
      flex-shrink: 0;
      width: 48%;
      padding-bottom: 48%;
      margin-bottom: 4.2%;

      &:last-child,
      :nth-last-child(2) {
        margin-bottom: 0;
      }
    }
  }

  @media (min-width: ${props => props.theme.mobileBreakpoint}px) {
    > * {
      height: ${props => props.containerWidth * 0.307}px;
      width: 49%;
    }
  }
`;

export default class TwoOne extends React.PureComponent<IProps> {
  render() {
    return (
      <Container containerWidth={this.props.containerWidth}>
        <VideoOrImage projectContent={this.props.projectContent} />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Project/ProjectContent/TwoOne.tsx